import React from "react";
import { Button, Space, Tag, Tooltip } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatMoney } from "../../../../utils/util";


export const accessColumns = ({ handleEdit, showAction = true }) => {
  const columns = [
    {
      title: "JO Code",
      dataIndex: "jocode",
      key: "jocode",
      width: 70,
      sorter: (a, b) => String(a?.jocode ?? "").localeCompare(String(b?.jocode ?? "")),
    },
    {
      title: "JO Date",
      dataIndex: "jodate",
      key: "jodate",
      width: 90,
      render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Customer",
      dataIndex: "cusname",
      key: "cusname",
      width: "15%",
      render: (value) => (
        <Tooltip title={value}>
          <span
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.4,
            }}
          >
            {value}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "PG",
      dataIndex: "pg_code",
      key: "pg_code",
      width: 120,
    },
    {
      title: "FG",
      dataIndex: "fg_code",
      key: "fg_code",
      width: 100,
    },
    {
      title: "Product",
      dataIndex: "pg_name",
      key: "pg_name",
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <span>{record?.pg_name}</span>
          <span className="text-zinc-500">{record?.fg_name}</span>
        </Space>
      ),
    },
    {
      title: "Order Qty",
      dataIndex: "total_unit",
      key: "total_unit",
      width: 120,
      align: "right",
      render: (_, record) =>
        formatMoney(Number(record?.carton || 0) * Number(record?.unit_cs || 0), 0),
    },
    {
      title: "BOM",
      dataIndex: "bom",
      key: "bom",
      width: 100,
      align: "center",
      render: (value) => <Tag color={value === "มีแล้ว" ? "success" : "warning"}>{value}</Tag>,
    },
    {
      title: "Master Process",
      dataIndex: "master_process",
      key: "master_process",
      width: 100,
      align: "center",
      render: (value) => <Tag color={value === "มีแล้ว" ? "success" : "warning"}>{value}</Tag>,
    },
  ];

  if (showAction && typeof handleEdit === "function") {
    columns.push({
      title: "Action",
      key: "action",
      width: 110,
      fixed: "right",
      render: (_, record) => (
        <Button type="primary" size="small" icon={<ArrowRightOutlined />} onClick={() => handleEdit(record)}>
          แก้ไขงาน
        </Button>
      ),
    });
  }

  return columns;
};

